import React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { PopoverContentFrame } from './Popover.styles'
import type { PopoverContentProps } from './Popover.types'

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverAnchor = PopoverPrimitive.Anchor
export const PopoverClose = PopoverPrimitive.Close

export const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  (
    {
      children,
      side = 'bottom',
      align = 'center',
      sideOffset = 8,
      collisionPadding = 8,
      width = 320,
      ...props
    },
    ref
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverContentFrame
        ref={ref}
        side={side}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        $width={width}
        {...props}
      >
        {children}
      </PopoverContentFrame>
    </PopoverPrimitive.Portal>
  )
)

PopoverContent.displayName = 'PopoverContent'
